import React, { useEffect, useState } from 'react';
import { mdiChartBar, mdiFormDropdown } from '@mdi/js';
import Icon from '@mdi/react';
import { useHistory, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import P from 'router/paths';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';

const items = [
  {
    label: 'Charts',
    url: P.RETENTION.CHARTS,
    key: 'chart',
    icon: <Icon path={mdiChartBar} />,
  },
  {
    label: 'CRM',
    key: 'crm',
    url: P.RETENTION.INDEX,
    icon: <Icon path={mdiFormDropdown} />,
  },
];

const RetentionMainMenu = ({ dateRangeComponent }) => {
  const { queryParams } = useWidgetDate('global');

  const [selected, setSelected] = useState();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const key = items.find((item) => item.url === location.pathname)?.key;
    setSelected(key);
  }, [location.pathname]);

  const onSelect = ({ key }) => {
    const selectedItem = items.find((item) => item.key === key);
    if (selectedItem) {
      history.push(selectedItem.url + queryParams);
      setSelected(key);
    }
  };

  return (
    <div className='flex px-4 pr-8 items-center justify-between flex-col sm:flex-row gap-2 pt-1'>
      <Menu
        className='w-full order-1 sm:order-0 !border-none'
        mode='horizontal'
        selectedKeys={[selected]}
        onSelect={onSelect}
        items={items}
      />
    </div>
  );
};
export default RetentionMainMenu;
